/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CandidateExperienceDefaultsDto,
  DeleteOrgLogoParams,
  GetCandidateExperienceDefaultsParams,
  GetOrgLogoParams,
  OrgLogoDto,
  UpdateCandidateExperienceDefaultsDto,
  UpdateCandidateExperienceDefaultsParams,
  UploadOrgLogoBody,
  UploadOrgLogoParams
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetOrgLogoUrl = (params: GetOrgLogoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/orgs/logo?${stringifiedParams}` : `/orgs/logo`
}

export const getOrgLogo = async (params: GetOrgLogoParams, options?: Parameters<typeof customFetch>[1]): Promise<OrgLogoDto> => {

  return customFetch<OrgLogoDto>(getGetOrgLogoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrgLogoQueryKey = (params?: GetOrgLogoParams,) => {
    return [
    `/orgs/logo`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrgLogoQueryOptions = <TData = Awaited<ReturnType<typeof getOrgLogo>>, TError = unknown>(params: GetOrgLogoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgLogoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgLogo>>> = ({ signal }) => getOrgLogo(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrgLogoQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgLogo>>>
export type GetOrgLogoQueryError = unknown


export function useGetOrgLogo<TData = Awaited<ReturnType<typeof getOrgLogo>>, TError = unknown>(
 params: GetOrgLogoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgLogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgLogo>>,
          TError,
          Awaited<ReturnType<typeof getOrgLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgLogo<TData = Awaited<ReturnType<typeof getOrgLogo>>, TError = unknown>(
 params: GetOrgLogoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgLogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgLogo>>,
          TError,
          Awaited<ReturnType<typeof getOrgLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrgLogo<TData = Awaited<ReturnType<typeof getOrgLogo>>, TError = unknown>(
 params: GetOrgLogoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrgLogo<TData = Awaited<ReturnType<typeof getOrgLogo>>, TError = unknown>(
 params: GetOrgLogoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgLogo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrgLogoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUploadOrgLogoUrl = (params: UploadOrgLogoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/orgs/logo?${stringifiedParams}` : `/orgs/logo`
}

export const uploadOrgLogo = async (uploadOrgLogoBody: UploadOrgLogoBody,
    params: UploadOrgLogoParams, options?: Parameters<typeof customFetch>[1]): Promise<OrgLogoDto> => {
    const formData = new FormData();
formData.append(`file`, uploadOrgLogoBody.file);

  return customFetch<OrgLogoDto>(getUploadOrgLogoUrl(params),
  {
    ...options,
    method: 'PUT'
    ,
    body: formData
  }
);}





export const getUploadOrgLogoMutationKey = () => ['uploadOrgLogo'] as const;

export const getUploadOrgLogoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrgLogo>>, TError,UploadOrgLogoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadOrgLogo>>, TError,UploadOrgLogoMutationVariables, TContext> => {

const mutationKey = getUploadOrgLogoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadOrgLogo>>, UploadOrgLogoMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  uploadOrgLogo(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadOrgLogoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadOrgLogo>>>
    export type UploadOrgLogoMutationBody = UploadOrgLogoBody
    export type UploadOrgLogoMutationError = unknown
    export type UploadOrgLogoMutationVariables = {data: UploadOrgLogoBody;params: UploadOrgLogoParams}

    export const useUploadOrgLogo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrgLogo>>, TError,UploadOrgLogoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadOrgLogo>>,
        TError,
        UploadOrgLogoMutationVariables,
        TContext
      > => {
      return useMutation(getUploadOrgLogoMutationOptions(options), queryClient);
    }
    export const getDeleteOrgLogoUrl = (params: DeleteOrgLogoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/orgs/logo?${stringifiedParams}` : `/orgs/logo`
}

export const deleteOrgLogo = async (params: DeleteOrgLogoParams, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteOrgLogoUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteOrgLogoMutationKey = () => ['deleteOrgLogo'] as const;

export const getDeleteOrgLogoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgLogo>>, TError,DeleteOrgLogoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrgLogo>>, TError,DeleteOrgLogoMutationVariables, TContext> => {

const mutationKey = getDeleteOrgLogoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrgLogo>>, DeleteOrgLogoMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  deleteOrgLogo(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrgLogoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrgLogo>>>

    export type DeleteOrgLogoMutationError = unknown
    export type DeleteOrgLogoMutationVariables = {params: DeleteOrgLogoParams}

    export const useDeleteOrgLogo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgLogo>>, TError,DeleteOrgLogoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrgLogo>>,
        TError,
        DeleteOrgLogoMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteOrgLogoMutationOptions(options), queryClient);
    }
    export const getGetCandidateExperienceDefaultsUrl = (params: GetCandidateExperienceDefaultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/orgs/candidate-experience-defaults?${stringifiedParams}` : `/orgs/candidate-experience-defaults`
}

export const getCandidateExperienceDefaults = async (params: GetCandidateExperienceDefaultsParams, options?: Parameters<typeof customFetch>[1]): Promise<CandidateExperienceDefaultsDto> => {

  return customFetch<CandidateExperienceDefaultsDto>(getGetCandidateExperienceDefaultsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCandidateExperienceDefaultsQueryKey = (params?: GetCandidateExperienceDefaultsParams,) => {
    return [
    `/orgs/candidate-experience-defaults`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCandidateExperienceDefaultsQueryOptions = <TData = Awaited<ReturnType<typeof getCandidateExperienceDefaults>>, TError = unknown>(params: GetCandidateExperienceDefaultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateExperienceDefaults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidateExperienceDefaultsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidateExperienceDefaults>>> = ({ signal }) => getCandidateExperienceDefaults(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidateExperienceDefaults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCandidateExperienceDefaultsQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidateExperienceDefaults>>>
export type GetCandidateExperienceDefaultsQueryError = unknown


export function useGetCandidateExperienceDefaults<TData = Awaited<ReturnType<typeof getCandidateExperienceDefaults>>, TError = unknown>(
 params: GetCandidateExperienceDefaultsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateExperienceDefaults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidateExperienceDefaults>>,
          TError,
          Awaited<ReturnType<typeof getCandidateExperienceDefaults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidateExperienceDefaults<TData = Awaited<ReturnType<typeof getCandidateExperienceDefaults>>, TError = unknown>(
 params: GetCandidateExperienceDefaultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateExperienceDefaults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCandidateExperienceDefaults>>,
          TError,
          Awaited<ReturnType<typeof getCandidateExperienceDefaults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCandidateExperienceDefaults<TData = Awaited<ReturnType<typeof getCandidateExperienceDefaults>>, TError = unknown>(
 params: GetCandidateExperienceDefaultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateExperienceDefaults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCandidateExperienceDefaults<TData = Awaited<ReturnType<typeof getCandidateExperienceDefaults>>, TError = unknown>(
 params: GetCandidateExperienceDefaultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCandidateExperienceDefaults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCandidateExperienceDefaultsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateCandidateExperienceDefaultsUrl = (params: UpdateCandidateExperienceDefaultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/orgs/candidate-experience-defaults?${stringifiedParams}` : `/orgs/candidate-experience-defaults`
}

export const updateCandidateExperienceDefaults = async (updateCandidateExperienceDefaultsDto: UpdateCandidateExperienceDefaultsDto,
    params: UpdateCandidateExperienceDefaultsParams, options?: Parameters<typeof customFetch>[1]): Promise<CandidateExperienceDefaultsDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<CandidateExperienceDefaultsDto>(getUpdateCandidateExperienceDefaultsUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCandidateExperienceDefaultsDto)
  }
);}





export const getUpdateCandidateExperienceDefaultsMutationKey = () => ['updateCandidateExperienceDefaults'] as const;

export const getUpdateCandidateExperienceDefaultsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCandidateExperienceDefaults>>, TError,UpdateCandidateExperienceDefaultsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCandidateExperienceDefaults>>, TError,UpdateCandidateExperienceDefaultsMutationVariables, TContext> => {

const mutationKey = getUpdateCandidateExperienceDefaultsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCandidateExperienceDefaults>>, UpdateCandidateExperienceDefaultsMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateCandidateExperienceDefaults(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCandidateExperienceDefaultsMutationResult = NonNullable<Awaited<ReturnType<typeof updateCandidateExperienceDefaults>>>
    export type UpdateCandidateExperienceDefaultsMutationBody = UpdateCandidateExperienceDefaultsDto
    export type UpdateCandidateExperienceDefaultsMutationError = unknown
    export type UpdateCandidateExperienceDefaultsMutationVariables = {data: UpdateCandidateExperienceDefaultsDto;params: UpdateCandidateExperienceDefaultsParams}

    export const useUpdateCandidateExperienceDefaults = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCandidateExperienceDefaults>>, TError,UpdateCandidateExperienceDefaultsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCandidateExperienceDefaults>>,
        TError,
        UpdateCandidateExperienceDefaultsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCandidateExperienceDefaultsMutationOptions(options), queryClient);
    }
